<div style="line-height: 1.5;">
    <div *ngIf="selectedSectionDetail && selectedSectionDetail.name=='Overview'; else faqDetail">
        <app-faq-overview [selectedSectionDetail]="selectedSectionDetail"></app-faq-overview>
    </div>
    <ng-template #faqDetail>
        <div>
            <app-faq [selectedSectionDetail]="selectedSectionDetail"></app-faq>
        </div>
    </ng-template>
</div>